import { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { staffApi, errMsg } from "../api";

const TYPES = ["image/jpeg", "image/png", "image/webp"];
const MAX = 15 * 1024 * 1024;

// Uploads one or more photos in sequence, reporting each result via onUploaded(photo).
export const PhotoUploader = ({ multiple = false, label, onUploaded, testId, variant = "btn-ghost" }) => {
  const input = useRef(null);
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState("");

  const upload = async (files) => {
    setError("");
    const list = Array.from(files || []);
    const problems = [];
    for (let i = 0; i < list.length; i += 1) {
      const f = list[i];
      if (!TYPES.includes(f.type)) { problems.push(`${f.name}: only JPG, PNG or WebP`); continue; }
      if (f.size > MAX) { problems.push(`${f.name}: larger than 15 MB`); continue; }
      setProgress({ n: i + 1, of: list.length, pct: 0 });
      const body = new FormData();
      body.append("file", f);
      try {
        const { data } = await staffApi.post("/news/photos", body, {
          onUploadProgress: (e) => setProgress({ n: i + 1, of: list.length, pct: e.total ? Math.round((e.loaded / e.total) * 100) : 0 }),
        });
        if (data?.photo) onUploaded(data);
      } catch (err) {
        problems.push(`${f.name}: ${await errMsg(err, "upload failed")}`);
      }
    }
    setProgress(null);
    setError(problems.join(" · "));
    if (input.current) input.current.value = "";
  };

  return (
    <div>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" multiple={multiple} className="hidden"
        onChange={(e) => upload(e.target.files)} data-testid={`${testId}-input`} />
      <button type="button" disabled={!!progress} onClick={() => input.current?.click()} className={`btn ${variant} disabled:opacity-60`} data-testid={testId}>
        {progress ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />}
        {progress ? `Uploading ${progress.n} of ${progress.of} (${progress.pct}%)` : label}
      </button>
      {error && <p className="mt-2 text-sm text-fire" role="alert" data-testid={`${testId}-error`}>{error}</p>}
    </div>
  );
};
